@for (s of sizes; track s) {<div class="{{s.class + ' ' + (prefix + s.id) }}"></div>}